import { createContext, useContext } from 'react'

/**
 * What a table row does when used. Provided once by the list with stable
 * functions, so memoized rows don't re-render when the page changes.
 */
export interface TableListActions {
  /** A row was chosen; the unpinned drawer closes. */
  onSelect?: () => void
  /** Opens a table's settings panel (the row menu's Manage table settings). */
  openTableSettings?: (tableId: string) => void
  /** Saves a folder's new name (the folder menu's Rename folder). */
  renameFolder?: (folderId: string, name: string) => void
  /** Deletes a folder, moving what it holds up a level (Delete folder). */
  deleteFolder?: (folderId: string) => void
}

export const TableListActionsContext = createContext<TableListActions>({})

export function useTableListActions(): TableListActions {
  return useContext(TableListActionsContext)
}
